import { getTargeterCookie } from './modules/utils.js'
import { initMegamenu } from './modules/megamenu.js'
import { initUtilmenu } from './modules/utilmenu.js'
import { google_tag_linker } from './modules/ga4.js'
import { Splide } from '@splidejs/splide'
import { initProductListTool } from './modules/product-list-tool.js'
import { initContact5 } from './modules/contact-5.js'
import { initCtaTool } from './modules/cta-tool.js'
import { initModalDialogModelB } from './modules/modal-dialog-model-b.js'
import { initBlog4 } from './modules/blog-4.js'
import { initHptp } from './modules/hptp.js'

document.addEventListener('DOMContentLoaded', async () => {
    // @ vars --------------------------------------------------
    const frm_inst_nav = document.getElementById('instance-navigation-form')
    const input_lat = frm_inst_nav.querySelector('#lat')
    const input_lng = frm_inst_nav.querySelector('#lng')

    // @ funcs --------------------------------------------------
    const initInstanceNav = async () => {
        const { Autocomplete } = await google.maps.importLibrary('places')
        const input_google_search = document.getElementById('instance-navigation-google-search')
        const autocomplete = new Autocomplete(input_google_search, {
            types: ['(regions)'],
        })

        input_google_search.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault()
            }
        })

        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace()

            if (place.geometry !== undefined) {
                handleFormInstanceNavigation(input_google_search.value, true)
            }
        })

        const targeter4_cookie = getTargeterCookie()

        if (typeof targeter4_cookie === 'undefined') {
            // @note: cookie not found, fill instance nav form via geocode request
            const { LatLng } = await google.maps.importLibrary('core')
            const latlng = new LatLng(parseFloat(input_lat.value), parseFloat(input_lng.value))
            handleFormInstanceNavigation(latlng)
        }
    }

    const getGeocodeResult = async (params) => {
        const { Geocoder } = await google.maps.importLibrary('geocoding')
        const { LatLng } = await google.maps.importLibrary('core')
        const geocoder = new Geocoder()

        switch (true) {
            case typeof params === 'string':
                params = { address: params }
                break

            case params instanceof LatLng:
                params = { location: params }
                break

            default:
                throw new Error('Invalid parameter type. Must be a string or LatLng.')
        }

        const { results } = await geocoder.geocode(params)
        const parsed_results = parseGeocodeResults(results)
        parsed_results['input_params'] = params

        // console.table(parsed_results)

        return parsed_results
    }

    const getGeocodeResultForInstanceNavigation = async (searchfor) => {
        let response = await getGeocodeResult(searchfor)

        if (!response.valid) {
            const { LatLng } = await google.maps.importLibrary('core')
            const latlng = new LatLng(response.lat, response.lng)
            response = await getGeocodeResult(latlng)
        }

        return response
    }

    // @note: mapping and skip must match exactly with
    // parseResponse in packages/targeter/library/geocode_request.php
    const parseGeocodeResults = (results) => {
        const mapping = {
            postal_code: 'postcode',
            locality: 'city',
            postal_town: 'city',
            administrative_area_level_1: 'overarching_region',
            administrative_area_level_2: 'region',
            administrative_area_level_3: 'district',
            administrative_area_level_4: 'fallback_city',
        }
        const skip = ['colloquial_area', 'establishment', 'plus_code', 'political', 'postal_code_prefix', 'route', 'street_number']
        const parsed_geocoder_results = {}

        if (results.length > 0) {
            results.forEach((result) => {
                result.address_components.forEach((address_component) => {
                    const types = address_component.types.filter((type) => !skip.includes(type))

                    if (types[0]) {
                        let key = types[0]
                        if (mapping[key]) {
                            key = mapping[key]
                        }
                        if (!parsed_geocoder_results[key]) {
                            parsed_geocoder_results[key] = address_component.long_name
                            if (key === 'country') {
                                parsed_geocoder_results['iso3166'] = address_component.short_name
                            }
                        }
                    }
                })
            })

            if (!parsed_geocoder_results.city && parsed_geocoder_results.fallback_city) {
                parsed_geocoder_results.city = parsed_geocoder_results.fallback_city
            }

            delete parsed_geocoder_results.fallback_city

            parsed_geocoder_results.lat = results[0].geometry.location.lat().toFixed(6)
            parsed_geocoder_results.lng = results[0].geometry.location.lng().toFixed(6)
            parsed_geocoder_results.valid = typeof parsed_geocoder_results.postcode === 'string'
        }

        return parsed_geocoder_results
    }

    const handleFormInstanceNavigation = async (searchfor, submit_data_form = false) => {
        try {
            const response = await getGeocodeResultForInstanceNavigation(searchfor)

            fillDataLayer(response)
            populateHiddenFieldsFrmInstNav(response)

            if (submit_data_form) {
                frm_inst_nav.submit()
            }
        } catch (err) {
            console.table(err)
        }
    }

    const fillDataLayer = (response) => {
        window.dataLayer = window.dataLayer || []
        dataLayer.push({
            UserAdminArea2: response.region,
            UserLocality: response.city,
            UserPostCode: response.postcode,
            event: 'customLocalityDimensionsLogged',
        })
    }

    const populateHiddenFieldsFrmInstNav = (response) => {
        const span_city = document.getElementById('span-city')
        const input_ga4 = document.getElementById('_gl-in')

        if (span_city) {
            span_city.innerText = response.city
        }

        const inputs_hidden = frm_inst_nav.querySelectorAll('.geocoder')

        inputs_hidden.forEach((input) => {
            input.value = response[input.id] || ''
        })

        input_ga4.value = google_tag_linker('get')
    }

    const injectSectionsCSS = () => {
        const css_sections = document.querySelectorAll('[data-css]')

        css_sections.forEach((section) => {
            const css_file = section.getAttribute('data-css')
            const css_src = `/themes/parentsite3/dist/styles/sections/${css_file}.css`
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.type = 'text/css'
            link.href = css_src

            document.head.appendChild(link)
        })
    }

    const initModuleTool4 = () => {
        var num_splides = document.querySelectorAll('.mod-tool-4__section .splide')

        if (num_splides.length > 0) {
            var splide = new Splide('.mod-tool-4__section .splide', {
                perPage: 1,
            })

            splide.on('mounted', function () {
                // $('.splide').css({
                //     overflow: 'visible',
                //     visibility: 'visible',
                //     height: 'auto',
                // })
            })

            splide.mount()
        }
    }

    // @ inits --------------------------------------------------
    initMegamenu()
    initUtilmenu()
    initInstanceNav()
    initModuleTool4()
    injectSectionsCSS()
    initProductListTool()
    initContact5()
    initCtaTool()
    initModalDialogModelB()
    initBlog4()
    initHptp()
})
